import { NavigationStep } from '@/types/navigation';

export enum NavigationStepEnum {
  SCAN_DETAILS = 'Scan Details',
  PATIENT_DETAILS = 'Patient Details',
  PAYMENT_DETAILS = 'Payment Details',
  CONFIRMATION = 'Confirmation',
}

export enum NavigationStepPathEnum {
  SCAN_DETAILS = '/',
  PATIENT_DETAILS = '/patient-details',
  PAYMENT_DETAILS = '/payment',
  CONFIRMATION = '/confirmation',
}

export const navigationSteps: NavigationStep[] = [
  {
    path: () => NavigationStepPathEnum.SCAN_DETAILS,
    label: NavigationStepEnum.SCAN_DETAILS,
  },
  {
    path: () => NavigationStepPathEnum.PATIENT_DETAILS,
    label: NavigationStepEnum.PATIENT_DETAILS,
  },
  {
    path: () => NavigationStepPathEnum.PAYMENT_DETAILS,
    label: NavigationStepEnum.PAYMENT_DETAILS,
  },
  {
    // TODO: add study_id back when dynamic route is implemented
    // path: (studyId) => `/confirmation/${studyId}`,
    path: () => NavigationStepPathEnum.CONFIRMATION,
    label: NavigationStepEnum.CONFIRMATION,
    isDynamic: true,
  },
];
